import { useRef } from 'react';
import { Box, styled, useTheme } from '@mui/material';

import Typography from '../Typography/Typography';
import { ColorInputProps } from './types';

const ColorInput = ({
  ariaLabel,
  color,
  label,
  onChange,
  subLabel,
}: ColorInputProps) => {
  const { palette } = useTheme();
  const colorInputRef = useRef<HTMLInputElement>(null);

  return (
    <Box display='flex' flexDirection='column' gap={1}>
      {label && <Typography variant='font16Bold'>{label}</Typography>}
      <Box
        alignItems='center'
        border={`1px solid ${palette.colors.grey[500]}`}
        display='flex'
        justifyContent='space-between'
        onClick={() => colorInputRef.current?.click()}
        padding='10px 16px'
        height='40px'
        boxSizing='border-box'
      >
        {subLabel ? (
          <Typography color={palette.colors.black} variant='font14'>
            {subLabel}
          </Typography>
        ) : (
          <Box />
        )}
        <Box display='flex' alignItems='center' gap={2}>
          <Typography variant='font14'>{color}</Typography>
          <ColorBox backgroundColor={color} />
        </Box>
      </Box>
      <ColorInputContainer
        aria-label={ariaLabel}
        onChange={onChange}
        ref={colorInputRef}
        value={color}
      />
    </Box>
  );
};

const ColorBox = styled('div', {
  shouldForwardProp: propName => propName !== 'backgroundColor',
})<{ backgroundColor: string }>`
  border-radius: 50%;
  width: 24px;
  height: 24px;
  box-sizing: border-box;
  background: ${props => props.backgroundColor};
  border: 1px solid ${props => props.theme.palette.colors.grey[500]};
  cursor: pointer;
`;

const ColorInputContainer = styled('input')`
  opacity: 0;
  width: 0;
  margin-right: -4px;
`;

// MUI style doesn't have attrs property (this is same behavior)
ColorInputContainer.defaultProps = {
  type: 'color',
};

export default ColorInput;
